import React, { useRef, useState, useEffect } from 'react';
import AppLayout from './AppLayout';
import { createIndex, search } from './search.tsx';
import { SEARCH_SORT_SCORE_ALPHA } from '../../modules/App/search.tsx';

export default function App({ exemptionData }) {
  const ref = useRef(null);

  const [searchTerm, setSearchTerm] = useState<string|null>(null);
  const [searchFilter, setSearchFilter] = useState({
      sectors: '',
      expired: null
    });
  const [sort, setSort] = useState<string>(SEARCH_SORT_SCORE_ALPHA);
  const [results, setResults] = useState([]);
  const [index, setIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    exemptionData.forEach(element => {
      element['expired'] = isExpired(element['endDate']);
    });

    const index = createIndex(exemptionData);
    setIndex(index);

    // If ?query is set then extract and carry out a search
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('query');

    if (query) {
      setSearchTerm(query);
    } else {
      setSearchTerm('');
    }
  }, []);

  useEffect(() => {
    if (index) {
      setResults(search(index, searchTerm, sort, searchFilter));
    }
  }, [searchTerm, sort, searchFilter]);

  const isExpired = (date:string) => {
    if (!date) {
      return null;
    };
    return new Date(date) < new Date()
      ? 'Expired'
      : 'In force';
  }

  const sectors = Array.from(
    new Set(exemptionData.flatMap(item => item.sectors || []))
  );

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value.trim());
    setCurrentPage(1);
  };
  const handleSortChange = (e) => setSort(e.target.value);
  const handlePageChange = (e) => setCurrentPage(e.target.value);
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setSearchFilter(prev => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  return (
    <div ref={ref}>
      <AppLayout
        handleSearchTermChange={handleSearchTermChange}
        handleSortChange={handleSortChange}
        handlePageChange={handlePageChange}
        handleFilterChange={handleFilterChange}
        results={results}
        filterOptions={sectors}
        searchTerm={searchTerm}
        currentPage={currentPage}
      ></AppLayout>
    </div>
  );
}
